import { inject, makeStateKey, TransferState } from "@angular/core";
import { forkJoin, of } from "rxjs";
import { debounceTime, switchMap } from "rxjs/operators";
import { TServiceResult } from "@shared/helper/t-service-result";
import { ResolveFn } from "@angular/router";
import { Book_BooklistModel } from "../models/Book_Booklist.model";

import { PageList } from "@shared/model/categoryAndSearch/pageList-model";
import { BooklistAggrigatorModel } from "../models/booklist-aggrigator-model";
import { BooklistAggrigatorService } from "../services/booklist-aggrigator.service";
import { TermFilterModel } from "@shared/model/categoryAndSearch/term-filter-model";
import { LocalRepository } from "@shared/helper/local-repository";

export const STATE_KEY_BOOKLIST = makeStateKey<BooklistStateModel>('Booklist_Resolver_Data');

export const BooklistDetailResolver: ResolveFn<BooklistStateModel> = (route) => {
    const booksTermFilter: TermFilterModel = new TermFilterModel(0, 20);
    const serverState: TransferState = inject(TransferState);
    const _localRepository: LocalRepository = inject(LocalRepository);
    const bookListAggService: BooklistAggrigatorService = inject(BooklistAggrigatorService);
    const booklistAggrigatorService: BooklistAggrigatorService = inject(BooklistAggrigatorService);

    if (!_localRepository.IsInBrowser) {
        return booklistAggrigatorService.getListDetail(route.paramMap.get('id')!)
            .pipe(
                debounceTime(0),
                switchMap(bookList =>
                    forkJoin({
                        bookList: of(bookList),
                        books: bookListAggService.getBooksOfBooklist(bookList.result.id!, booksTermFilter)
                    })
                ),
                switchMap(forkedData => {
                    const data = BooklistStateModel.getInstance(forkedData)
                    serverState.set(STATE_KEY_BOOKLIST, data);
                    return of(data);
                })
            );
    }
    else {
        return of(serverState.get(STATE_KEY_BOOKLIST, BooklistStateModel.getInstanceAllErros()));
    }

}



export class BooklistStateModel {
    bookList!: TServiceResult<BooklistAggrigatorModel>;
    books!: TServiceResult<PageList<Book_BooklistModel>>;


    public static getInstance(forkData: any): BooklistStateModel {
        const instance = new BooklistStateModel();
        instance.bookList = forkData?.bookList != undefined ? forkData.bookList : TServiceResult.fromFailure<any>(null);
        instance.books = forkData?.books != undefined ? forkData.books : TServiceResult.fromFailure<any>(null);
        return instance;
    }

    public static getInstanceAllErros(): BooklistStateModel {
        const instance = new BooklistStateModel();
        instance.books = TServiceResult.fromFailure<any>(null);
        instance.bookList = TServiceResult.fromFailure<any>(null);
        return instance;

    }
}